import { fromJS } from "immutable";

import { buyplanIdActions } from "actions/buyplanIdActions.js"

const initialState = fromJS({
  isLoading: true,
  hasErrors: false,
  data: {
    id: null,
    state: null
  }
});

export default (state = initialState, action) => {
  const payload = action.payload;

  switch (action.type) {
    case buyplanIdActions.startLoader:
      return state.set("isLoading", true);
    case buyplanIdActions.success:
      return state
        .merge({
          hasErrors: false,
          isLoading: false
        })
        .set("data", fromJS(payload.data));
    case buyplanIdActions.failure:
      return state
        .merge({
          hasErrors: true,
          isLoading: false
        })
    default:
      return state;
  }
};

